export default __webpack_public_path__ + "static/media/12.cf0c4d8e.jpeg";